export let serialize = function (obj, prefix) {
  let str = [];
  let p;

  for (p in obj) {
   
    if (obj.hasOwnProperty(p)) {
      let k = prefix ? prefix + "[" + p + "]" : p;
      let v = obj[p];
      str.push(
        v !== null && typeof v === "object"
          ? serialize(v, k)
          : encodeURIComponent(k) + "=" + encodeURIComponent(v)
      );
    }
  }

  return str.join("&");
};

export const getRandomString = (string_length) => {
  let rendomStringLength = 5;

  if (typeof string_length !== "undefined") rendomStringLength = string_length;
  let result = "";
  let characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let charactersLength = characters.length;

  for (let i = 0; i < rendomStringLength; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const setCookie = (name = null, value = null, options = {}) => {
  options = {
    path: '/',
    expires: new Date(new Date().getTime() + (1000 * 5184000)).toUTCString(),
    ...options
  };

  if (typeof (value) === 'object') {
    value = JSON.stringify(value);
  }

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }
  document.cookie = updatedCookie;
};

export const getCookie = (name) => {
  let matches = document.cookie.match(
    new RegExp(
      "(?:^|; )" +
      name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +  // eslint-disable-line
      "=([^;]*)"
    )
  );

  if (name === "language") {
    let navigator_name =
      window.navigator.language || window.navigator.userLanguage;
    return matches
      ? decodeURIComponent(matches[1])
      : navigator_name.split("-")[0];
  }
  let value = matches ? decodeURIComponent(matches[1]) : null;

  try {
    value = JSON.parse(value);
  } catch (e) { }

  return value;
};


export const getDateFormat = ( format = 'y-m-d h:i:s', date = null ) => {
  if ( date === null ) {
    let current_date = new Date();
    date = new Date( current_date.getUTCFullYear(), current_date.getUTCMonth(), current_date.getUTCDate(), current_date.getUTCHours(), current_date.getUTCMinutes(), current_date.getUTCSeconds() );
  }

  let year = date.getFullYear();
  format = format.replace('y', year);

  let month = date.getMonth() + 1;
  if (month < 10)
    month = '0' + month;
  format = format.replace('m', month);

  let day = date.getDate();
  if (day < 10)
    day = '0' + day;
  format = format.replace('d', day);

  let hours = date.getHours();
  if (hours < 10)
    hours = '0' + hours;
  format = format.replace('h', hours);

  let minutes = date.getMinutes();
  if (minutes < 10)
    minutes = '0' + minutes;
  format = format.replace('i', minutes);

  let seconds = date.getSeconds();
  if (seconds < 10)
    seconds = '0' + seconds;
  format = format.replace('s', seconds);

  return format;
}



